import { Box } from '@/UI/Box/Box';
import { firstFrameSrc } from '@/utils/assetUrls';
import type { ThumbnailSource } from '@/utils/assetUrls';
import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@/UI/theme.exports';

interface AssetThumbnailProps {
  source: ThumbnailSource;
  alt?: string;
  sx?: SxProps<Theme>;
  style?: CSSProperties;
  className?: string;
  draggable?: boolean;
}

export function AssetThumbnail({ source, alt = '', sx, style, className, draggable }: AssetThumbnailProps) {
  if (source.kind === 'none') {
    return null;
  }

  if (source.kind === 'firstFrame') {
    return (
      <Box
        component="video"
        src={firstFrameSrc(source.src)}
        muted
        playsInline
        preload="metadata"
        aria-label={alt || undefined}
        draggable={draggable}
        sx={sx}
        style={style}
        className={className}
      />
    );
  }

  return (
    <Box component="img" src={source.src} alt={alt} draggable={draggable} sx={sx} style={style} className={className} />
  );
}
